
import React from 'react';
import { Trophy } from 'lucide-react';

interface PerfectLevelIndicatorProps {
  isPerfect: boolean;
  isSpellingLevel: boolean;
  bonusAmount: number;
  isPracticeMode: boolean;
}

const PerfectLevelIndicator = ({ 
  isPerfect, 
  isSpellingLevel, 
  bonusAmount, 
  isPracticeMode 
}: PerfectLevelIndicatorProps) => {
  if (!isPerfect || isPracticeMode) return null;

  return (
    <div className="flex flex-col items-center mt-4 mb-6">
      <Trophy className="h-12 w-12 text-yellow-500 animate-bounce" />
      <div className="mt-3 font-bold text-lg text-yellow-600 animate-pulse">
        {isSpellingLevel ? 'Perfect Spelling!' : 'Perfect Level!'} +{bonusAmount} XP Bonus
      </div>
    </div>
  );
};

export default PerfectLevelIndicator;
